import { COLORS } from "shared/consts";

export const CloseIcon = () =>
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
         width="24.000000" height="24.000000" fill="none">
        <path id="Union"
              d="M10.9401 12.0005L4.99902 17.9416L6.05968 19.0023L12.0008 13.0612L17.9418 19.0023L19.0025 17.9416L13.0614 12.0005L19.0025 6.05944L17.9418 4.99878L12.0008 10.9399L6.0597 4.99878L4.99904 6.05944L10.9401 12.0005Z"
              fill={COLORS.NEUTRAL.DEFAULT} fillRule="evenodd"/>
    </svg>

